<script lang="ts" setup>
import { ref } from 'vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import { APP_VERSION } from '@/constants';

const isSidebarToggled = ref(false);

// Listen to an event emitted from SidebarComponent to update `isSidebarToggled`
function handleSidebarToggle(toggled: boolean) {
  isSidebarToggled.value = toggled;
}
</script>

<template>
  <div id="app">
    <!-- Sidebar -->
    <SidebarComponent @toggle="handleSidebarToggle" />
    <!-- Page Content -->
    <div
      id="content"
      :class="{ 'sidebar-visibility-toggled': isSidebarToggled }"
    >
      <div>
        <slot />
      </div>
      <!-- Page Footer -->
      <div id="footer">
        <p class="copyright">
          &#169; Sampling Human, Inc. All Rights Reserved.
        </p>
        <p class="links">
          <!-- Open www.samplinghuman.com terms and conditions and privacy policy in new tab -->
          <a
            href="https://www.samplinghuman.com/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
          <!-- enabled by uncommenting once Privacy Policy is published 
          |
          <a
            href="https://www.samplinghuman.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>-->
          <!-- Deprecated original terms and conditions, privacy policy and cloud terms routes 
          <RouterLink :to="{ name: 'TermsAndConditions' }"
            >Terms and Conditions</RouterLink
          >
          |
          <RouterLink :to="{ name: 'PrivacyPolicy' }"
            >Privacy Policy</RouterLink
          >
          | <RouterLink :to="{ name: 'CloudTerms' }">Cloud Terms</RouterLink
          >-->
          <br />
          {{ APP_VERSION }}
          <br />
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Include any styles needed for the layout */
#app {
  display: flex;
}
#content {
  padding: 2rem 100px;
  margin-left: 300px;
  width: 100vw;
  color: #444;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: rgba(250, 250, 250, 0.85);
  overflow: auto;
}
#content.sidebar-visibility-toggled {
  margin-left: 0;
}

#content h1 {
  color: darkslategray;
  margin-bottom: 1rem;
}
#content h2 {
  color: darkslategray;
}
#content h3 {
  color: darkslategray;
}
#content h4 {
  color: darkslategray;
}
#content h5 {
  color: darkslategray;
}

#content .card {
  max-width: 18rem;
}

#content #footer {
  text-align: center;
  font-size: 0.75rem;
  margin-top: auto; /* push to the bottom if content short */
  color: darkslategray;
}
#content #footer p.copyright {
  margin-top: 2rem;
  margin-bottom: 0;
}
#content #footer p.links {
  color: darkslategray;
}
#content #footer p.links a {
  color: darkslategray;
}

/* RESPONSIVE */
@media screen and (max-width: 1000px) {
  /* Provide space above/next-to the content for menu icon */
  #content {
    padding-top: 25px;
  }
  #content.sidebar-visibility-toggled {
    padding-top: 100px;
  }
  /* keep content full width */
  #content {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media screen and (max-width: 700px) {
  /* default page (fully visible) -> keep content full width and provide space above/next-to the content for menu icon */
  #content {
    margin-left: 0;
    padding-top: 100px;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  /* sidebar open -> move content out of the way of the sidebar when shown */
  #content.sidebar-visibility-toggled {
    margin-left: -100vw;
    overflow: hidden;
  }
}

/* Add any other necessary styles */
</style>
